import { ACCENT_COLORS } from '@/constants/colors';

export const CHART_HEIGHT = 300;

export const COLUMN_WIDTH = '60%';

export const BAR_RADIUS = 6;

export const LINE_WIDTH = 2.25;

export const TICK_COUNT = 6;

export const REVENUE_STEPS = [
  10000, 20000, 25000, 50000, 100000, 200000, 250000, 500000, 1000000,
];

export const GROWTH_STEPS = [0.05, 0.1, 0.2, 0.25, 0.5, 1, 2];

export const CHIP_CLEARANCE = 0.14;

export const LEGEND_ITEMS = [
  { label: 'Revenue', color: ACCENT_COLORS.primary },
  { label: 'YoY growth', color: ACCENT_COLORS.teal, shape: 'line' as const },
];
